import React from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import { useState } from "react";
import { CustomLableButton } from "../../Utils/CustomButton/CustomButton";

export default function ListItem({ props, width }) {
  // const [stateElem, setStateElem] = useState(Object.entries(props));

  let StateHandler = function () {
    switch (props.stateCode) {
      case 1:
        return (
          <>
            <StateLableActive />
            <StateLable />
            <StateLable />
          </>
        );
      case 2:
        return (
          <>
            <StateLableActive />
            <StateLableActive />
            <StateLable />
          </>
        );
      case 3:
        return (
          <>
            <StateLableActive />
            <StateLableActive />
            <StateLableActive />
          </>
        );
      default:
        break;
    }
  };
  // console.log(Object.entries(props).slice(0, Object.keys(props).length - 1));

  return (
    <Container>
      <Text myWidth={width}>{props.id}</Text>
      <Text
        myWidth={width}
        style={{
          direction: "ltr",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {props.code}
      </Text>
      <Text myWidth={width}>{props.title}</Text>
      <Text myWidth={width}>{props.to}</Text>
      <Text myWidth={width}>
        <StateContainer>
          {props.state}
          <StateLableContainer>{StateHandler()}</StateLableContainer>
        </StateContainer>
      </Text>
      <Text myWidth={width}>{props.attachment}</Text>
      {props.buttonImg.map((data) => {
        return <CustomLableButton Img={data} Dis="1.5rem"/>;
      })}
    </Container>

    // <Container>
    //   {stateElem.map((data, index) => {
    //     if (index < 4)
    //       return (
    //         <Text key={index + 1} myWidth={width}>
    //           {data[1]}
    //         </Text>
    //       );
    //     else if (index === 4)
    //       return (
    //         <Text key={index + 1} myWidth={width}>
    //           <StateContainer>
    //             {data[1]}
    //             <StateLableContainer>{StateHandler()}</StateLableContainer>
    //           </StateContainer>
    //         </Text>
    //       );
    //     else if (index === 6)
    //       return (
    //         <Text key={index + 1} myWidth={width}>
    //           {data[1]}
    //         </Text>
    //       );
    //   })}
    //   {props.buttonImg.map((data, index) => {
    //     return <CustomLableButton key={index + 1} Img={data} />;
    //   })}
    // </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  border: 2px solid ${Theme.colorBorderTextField};
  margin: 1rem;
  padding: 0 1rem;
  border-radius: 8px;
`;

const Text = styled.p`
  color: ${Theme.colorFontBlack};
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontWeigh};
  width: ${(props) => props.myWidth};
  margin: 0.7rem 0;
`;

const StateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;
const StateLableContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
`;

const StateLable = styled.div`
  width: 25px;
  height: 5px;
  background-color: ${Theme.colorBackgroundBoxLable};
  border-radius: 8px;
  margin: 5px 0 5px 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: all 500ms ease;

  &:hover {
    transform: translateY(-1px);
    background-color: ${Theme.colorBackgroundBoxHover};
    opacity: 0.5;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
`;

const StateLableActive = styled.div`
  width: 25px;
  height: 5px;
  background-color: ${Theme.colorBackgroundBoxLableActive};
  border-radius: 8px;
  margin: 5px 0 5px 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: all 500ms ease;

  &:hover {
    transform: translateY(-1px);
    opacity: 0.9;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
`;
